import { Component, Inject, Input, OnInit } from '@angular/core';
import {
	ApplicationService,
	Notification,
	NOTIFICATION_EVENT_TYPE,
	NotificationService,
	ProgramService
} from '@edassist/api';
import * as moment from 'moment-timezone';
import {
	constants,
	HybridAppService,
	NOTIFICATION_OBJECT_TYPE,
	WINDOW,
	UserTypeService,
	LocalStorageService
} from '@edassist/common';
import { concatMap } from 'rxjs/operators';

@Component({
	selector: 'ea-application-event-notification',
	templateUrl: './application-event-notification.component.html',
	styleUrls: [
		'./application-event-notification.component.scss',
		'../notifications.component.scss'
	]
})
export class ApplicationEventNotificationComponent implements OnInit {
	@Input() notification: Notification;
	@Input() isAdminNotification: boolean;

	notificationTimeZone: string;
	notificationObjectType: string;
	constants = constants;
	showEmail = false;
	hideAppealApproverName: boolean;
	toggleEmailText = constants.NOTIFICATIONS.SHOW_EMAIL;
	private pageUrl: string;
	constructor(
		@Inject(WINDOW) private readonly window: Window,
		private readonly hybridAppService: HybridAppService,
		private readonly notificationService: NotificationService,
		private readonly applicationService: ApplicationService,
		private readonly programService: ProgramService
	) {}

	ngOnInit(): void {
		this.notificationTimeZone = moment(new Date(this.notification.eventDate))
			.tz(moment.tz.guess())
			.zoneAbbr();
		this.setPageUrl();
		this.setNotificationObjectType();
		if (this.notification.eventType === 'APPEAL_COMMENT') {
			this.applicationService
				.getApplicationData(this.notification.applicationId)
				.pipe(
					concatMap((applicationData) =>
						this.programService.getAppealConfigForProgram(
							applicationData.programId
						)
					)
				)
				.subscribe((appealData) => {
					this.hideAppealApproverName = appealData.hideAppealApproverName;
				});
		}
	}

	navigateToApplication(): void {
		if (!this.notification.read && !this.isAdminNotification) {
			this.notificationService
				.updateNotification(this.notification)
				.subscribe((notification) => {
					this.notification.read = notification.read;
					this.window.location.href = this.pageUrl;
				});
		} else {
			this.window.location.href = this.pageUrl;
		}
	}

	markAsRead(): void {
		if (!this.notification.read && !this.isAdminNotification) {
			this.notificationService
				.updateNotification(this.notification)
				.subscribe((notification) => {
					this.notification.read = notification.read;
				});
		}
	}

	toggleEmail(): void {
		if (!this.notification.read && !this.isAdminNotification) {
			this.notificationService
				.updateNotification(this.notification)
				.subscribe(
					(notification) => (this.notification.read = notification.read)
				);
		}
		this.showEmail = !this.showEmail;
		this.toggleEmailText =
			this.showEmail ?
				constants.NOTIFICATIONS.HIDE_EMAIL
			:	constants.NOTIFICATIONS.SHOW_EMAIL;
	}

	private setNotificationObjectType(): void {
		switch (this.notification.eventType) {
			case NOTIFICATION_EVENT_TYPE.APPEAL_STATUS_CHANGE:
			case NOTIFICATION_EVENT_TYPE.APPEAL_COMMENT:
				this.notificationObjectType =
					NOTIFICATION_OBJECT_TYPE.APPEAL.toLowerCase();
				break;
			case NOTIFICATION_EVENT_TYPE.APPLICATION_STATUS_CHANGE:
			case NOTIFICATION_EVENT_TYPE.APPLICATION_COMMENT:
			case NOTIFICATION_EVENT_TYPE.SYSTEM_GENERATED_EMAIL:
			default:
				this.notificationObjectType =
					NOTIFICATION_OBJECT_TYPE.APPLICATION.toLowerCase();
		}
	}

	private setPageUrl(): void {
		const user = LocalStorageService.getItem(
			constants.localStorageKeys.CURRENT_USER
		);
		if (UserTypeService.isInternalAdmin(user.userTypeId)) {
			this.pageUrl = `${this.window.location.origin}/${constants.BASE_APP_ROUTES.application}${this.notification.applicationId}`;
		} else {
			this.pageUrl = this.hybridAppService.generateHybridAppUrl(
				`${constants.BASE_APP_ROUTES.application}${this.notification.applicationId}`
			);
		}
	}
}
